<template>
  <section id="depoimentos">
    <div class="testimonials-title-wrap reveal">
      <div class="section-tag" style="justify-content: center">{{ sectionData.tag }}</div>
      <h2 class="section-title">
        {{ sectionData.titlePrefix }}<br /><span class="green">{{ sectionData.titleAccent }}</span>
      </h2>
    </div>

    <div class="testimonials-wrapper">
      <div class="testimonials-track">
        <div
          v-for="(testimonial, index) in duplicatedCards"
          :key="index"
          class="testimonial-card"
        >
          <div class="testimonial-content">
            <span class="testimonial-quote">"</span>
            <p class="testimonial-text">{{ testimonial.text }}</p>
          </div>

          <div class="testimonial-author">
            <div class="author-avatar">
              <img v-if="testimonial.image" :src="testimonial.image" :alt="testimonial.name" class="avatar-img" />
              <span v-else>{{ testimonial.avatar }}</span>
            </div>
            <div>
              <div class="author-name">{{ testimonial.name }}</div>
              <div class="author-trail"><i class="fa-brands fa-instagram"></i> {{ testimonial.trail }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "TestimonialsSection",
  props: {
    sectionData: {
      type: Object,
      required: true
    }
  },
  computed: {
    duplicatedCards() {
      // Duplicate to allow seamless marquee scrolling
      if (!this.sectionData || !this.sectionData.cards) return [];
      return [...this.sectionData.cards, ...this.sectionData.cards];
    }
  }
};
</script>
